"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import * as Aria from 'react-aria-components';
import { TextFieldBase } from '../TextFieldBase/TextFieldBase.mjs';
import styles from './TextField.module.scss.mjs';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { ReactAriaControlledValueFix } from '../../lib/react/ReactAriaControlledValueFix.mjs';

const TextField = flowComponent("TextField", (props) => {
  const { children, placeholder, ref, form, ...rest } = props;
  const input = /* @__PURE__ */ jsx(ReactAriaControlledValueFix, { inputContext: Aria.InputContext, props, children: /* @__PURE__ */ jsx(
    Aria.Input,
    {
      form,
      placeholder,
      className: styles.textField,
      ref
    }
  ) });
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsx(TextFieldBase, { ...rest, input, children }) });
});

export { TextField, TextField as default };
//# sourceMappingURL=TextField.mjs.map
